import { getDataLayer, getPrice } from 'common/utilities/utils';
import { AnalyticsService } from '@kfc-global/react-shared/analytics';

export const getUniqueSizes = (modifiers, savedModifiers, currencyConversionFactor) => {
  let id = -1;
  let saveMod = savedModifiers
    .map(mod => {
      return (
        mod.size && {
          name: mod.size,
          rate: getPrice(mod.availability[0], currencyConversionFactor),
        }
      );
    })
    .filter(item => item)
    .sort((a, b) => a.rate - b.rate);

  let upsizeOptions = modifiers
    .map(mod => {
      return (
        mod.size && {
          name: mod.size,
          rate: getPrice(mod.availability[0], currencyConversionFactor),
        }
      );
    })
    .filter(item => item)
    .sort((a, b) => a.rate - b.rate);

  let uniquesaveMod = Array.from(new Set(saveMod.map(a => a.name))).map(name => {
    return saveMod.find(a => a.name === name);
  });

  uniquesaveMod.forEach(obj => {
    id =
      obj.name !== 'regular' ? upsizeOptions.findIndex(data => data.name === obj.name && data.rate !== obj.rate) : -1;
  });

  id >= 0 && upsizeOptions.splice(id, 1);

  return Array.from(new Set(upsizeOptions.map(a => a.name))).map(val => {
    return upsizeOptions.find(a => a.name === val);
  });
};

/**
 * Method to set analytics items in the data layer object
 */
export const setAnalyticsDataForUpsize = async addOnType => {
  const analyticsItems = [];
  analyticsItems.push({
    event: 'upsizeOrder',
    addOnType: addOnType,
    location: 'Customization Modal',
  });
  await AnalyticsService.registerEvent(
    undefined,
    {
      data: analyticsItems[0],
    },
    getDataLayer,
  );
};

export const setAnalyticsDataOnConfirm = async addOnType => {
  const analyticsItems = [];
  analyticsItems.push({
    event: 'confirmUpsize',
    changesMade: addOnType,
  });
  await AnalyticsService.registerEvent(
    undefined,
    {
      data: analyticsItems[0],
    },
    getDataLayer,
  );
};
